import React, { useState, useEffect } from 'react';
import {
  ChevronDown,
  X,
  Menu,
  Facebook,
  Linkedin,
  Youtube,
  Phone,
  Mail,
  ArrowRight
} from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import oldLogo from '../img/torchbearer-logo.png';
const newLogo = '/img/newlogo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleDropdown = (dropdown) => {
    if (openDropdown === dropdown) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdown);
    }
  };

  const servicesItems = [
    { name: 'Green Hydrogen', href: '/training/green-hydrogen' },
    { name: 'Electric Vehicle', href: '/training/electric-vehicles' },
    { name: 'Solar System', href: '/training/solar' },
    { name: 'Electrical', href: '/training/electrical' },
    { name: 'Occupation Safety and Health training', href: '/training/safety-training' },
    { name: 'Professional Branding', href: '/training/branding' },
  ];

  const trainingItems = [
    { name: 'Upcoming Training', href: '/training/upcoming' },
    { name: 'Past Training', href: '/training/pasttraining' },
  ];

  const webinarItems = [
    { name: 'Upcoming Webinars', href: '/training/webinars' },
    { name: 'Past Webinar Recordings', href: '/training/pastwebinars' },
  ];

  const communityItems = [
    { name: 'Events', href: '/training/community/events' },
    { name: 'Resources', href: '/training/community/resources' },
    { name: 'Links', href: '/training/community/links' },
    { name: 'Gallery', href: '/training/community/gallery' },
    { name: 'Newsletter', href: '/training/community/newsletter' },
    { name: 'Calendar of Events', href: '/training/community/calendar' },
  ];

  const navItems = [
    { name: 'About Us', href: '/training/about' },
    { name: 'Services', href: '/training', dropdown: servicesItems },
    { name: 'Trainings', href: '/training', dropdown: trainingItems },
    { name: 'Webinars', href: '/training/webinars', dropdown: webinarItems },
    { name: 'Community', href: '/community', dropdown: communityItems },
    { name: 'Contact', href: '/training/contact' }
  ];

  return (
    <header className="fixed w-full top-0 z-50">
      {/* Top Bar - Hidden on scroll to save space, shown on wide screens */}
      {!isScrolled && (
        <div className="bg-[#D97706] text-white py-1.5 px-6 md:px-12 hidden md:block transition-all duration-300 border-b border-black/5">
          <div className="max-w-7xl mx-auto flex justify-between items-center text-[10px] font-black uppercase tracking-[0.1em]">
            <div className="flex items-center gap-6">
              <a href="mailto:training@torchbearer.co.ke" className="flex items-center gap-2 hover:text-amber-100 transition-colors">
                <Mail size={12} strokeWidth={3} />
                <span className="hidden sm:inline">training@torchbearer.co.ke</span>
              </a>
              <a href="tel:+254789173033" className="flex items-center gap-2 hover:text-amber-100 transition-colors">
                <Phone size={12} strokeWidth={3} />
                <span>+254 789 173033</span>
              </a>
            </div>
            <div className="flex items-center gap-5">
              <span className="text-[9px] opacity-70 hidden sm:inline">Follow Us:</span>
              <div className="flex items-center gap-4">
                <a href="https://www.facebook.com/profile.php?id=61572958352380" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform"><Facebook size={14} strokeWidth={2.5} /></a>
                <a href="https://www.linkedin.com/company/torchbearer-institute-of-technologies" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform"><Linkedin size={14} strokeWidth={2.5} /></a>
                <a href="https://www.tiktok.com/@torchbearersinstitute" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform"><FaTiktok size={14} /></a>
                <a href="https://www.youtube.com/@TORCHBEARERINSITTUTE" target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform"><Youtube size={14} strokeWidth={2.5} /></a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Navbar */}
      <div className={`w-full transition-all duration-300 ${isScrolled ? 'bg-[#f4ebdc]/95 backdrop-blur-md shadow-lg py-0 md:py-2 border-b border-gray-100' : 'bg-[#f4ebdc] py-0 md:py-5 border-b border-gray-200'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        <div className="flex justify-between items-center h-16 md:h-auto">
          <div className="flex items-center">
            {/* Logo Section */}
            <Link to="/" className="flex items-center gap-3 z-50 mr-2 md:mr-16">
              {/* Responsive Logo Display */}
              <img src={oldLogo} alt="Torchbearer Logo" className="hidden md:block w-14 h-14 object-contain" />
              <img src={newLogo} alt="Torchbearer Logo Mobile" className="block md:hidden w-[160px] h-[50px] object-contain object-left scale-125 origin-left" />
              <div className="hidden md:flex flex-col">
                <span className="text-sm md:text-lg font-black text-[#D97706] leading-tight tracking-tight whitespace-nowrap">
                  Torchbearer Institute of Technologies
                </span>
                <span className="hidden sm:block text-[8px] md:text-xs text-gray-500 font-medium leading-tight">
                  Empower the mind energize the community
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center lg:gap-4 xl:gap-8">
            {navItems.map((item) => (
              <div
                key={item.name}
                className="relative group"
                onMouseEnter={() => item.dropdown && setOpenDropdown(item.name)}
                onMouseLeave={() => item.dropdown && setOpenDropdown(null)}
              >
                {item.dropdown ? (
                  <div className="flex items-center gap-1.5 cursor-pointer py-6 group relative">
                    <span className="text-[11px] font-bold text-gray-600 group-hover:text-[#D97706] uppercase tracking-[0.15em] transition-all duration-300">
                      {item.name}
                    </span>
                    <ChevronDown size={12} className="text-gray-400 group-hover:text-[#D97706] group-hover:rotate-180 transition-all duration-300" />
                    
                    {/* Hover indicator line */}
                    <div className="absolute bottom-4 left-0 w-0 h-0.5 bg-[#D97706] transition-all duration-500 group-hover:w-full opacity-0 group-hover:opacity-100"></div>
                  </div>
                ) : (
                  <Link to={item.href} className="flex items-center py-6 group relative">
                    <span className="text-[11px] font-bold text-gray-600 group-hover:text-[#D97706] uppercase tracking-[0.15em] transition-all duration-300">
                      {item.name}
                    </span>
                    {/* Hover indicator line */}
                    <div className="absolute bottom-4 left-0 w-0 h-0.5 bg-[#D97706] transition-all duration-500 group-hover:w-full opacity-0 group-hover:opacity-100"></div>
                  </Link>
                )}

                  {/* Dropdown Menu Overlay */}
                  {item.dropdown && openDropdown === item.name && (
                    <div className="absolute left-1/2 -translate-x-1/2 top-full -mt-2 w-72 bg-white/95 backdrop-blur-xl border border-white rounded-2xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.1)] overflow-hidden animate-in fade-in slide-in-from-top-4 duration-300 pointer-events-auto">
                      <div className="p-3">
                        {item.dropdown.map((subItem) => (
                          <Link
                            key={subItem.name}
                            to={subItem.href}
                            className="flex items-center p-4 text-[13px] font-bold text-gray-700 hover:bg-[#D97706]/5 hover:text-[#D97706] rounded-xl transition-all duration-300 group/item"
                            onClick={() => setOpenDropdown(null)}
                          >
                            <span className="flex-grow">{subItem.name}</span>
                            <ArrowRight size={14} className="opacity-0 -translate-x-2 group-hover/item:opacity-100 group-hover/item:translate-x-0 transition-all" />
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            ))}
          </nav>
        </div>

          {/* Mobile Toggle */}
          <div className="flex items-center gap-4 z-50">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden text-gray-600 hover:text-amber-600 p-2 transition-colors"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-[#f4ebdc] z-40 lg:hidden transition-transform duration-300 pt-24 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="px-6 space-y-2 pb-20 max-h-screen overflow-y-auto">
          {navItems.map((item) => (
            <div key={item.name} className="border-b border-gray-100">
              {item.dropdown ? (
                <div>
                  <button
                    onClick={() => toggleDropdown(item.name)}
                    className="w-full flex items-center justify-between py-4 text-left"
                  >
                    <span className="text-sm font-bold text-gray-900 uppercase tracking-widest">{item.name}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openDropdown === item.name ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openDropdown === item.name ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`}>
                    <div className="pl-4 border-l border-gray-200 space-y-3">
                      {item.dropdown.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          className="block text-sm text-gray-600 hover:text-amber-600 transition-colors"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link
                  to={item.href}
                  className="block py-4 text-sm font-bold text-gray-900 uppercase tracking-widest"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              )}
            </div>
          ))}

          {/* Social icons in mobile menu */}
          <div className="pt-10 border-t border-gray-100">
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-4 text-center">Contact & Social</p>
            <div className="flex flex-col gap-4 mb-8">
              <a href="tel:+254789173033" className="flex items-center justify-center gap-3 text-sm font-bold text-gray-600">
                <Phone size={16} className="text-amber-600" />
                <span>+254 789 173033</span>
              </a>
              <a href="mailto:training@torchbearer.co.ke" className="flex items-center justify-center gap-3 text-xs font-bold text-gray-500">
                <Mail size={16} className="text-amber-600" />
                <span>training@torchbearer.co.ke</span>
              </a>
            </div>
            <div className="flex justify-center items-center gap-6 pb-6">
              <a href="https://www.facebook.com/profile.php?id=61572958352380" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-amber-600"><Facebook size={20} /></a>
              <a href="https://www.linkedin.com/company/torchbearer-institute-of-technologies" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-amber-600"><Linkedin size={20} /></a>
              <a href="https://www.tiktok.com/@torchbearersinstitute" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-amber-600"><FaTiktok size={18} /></a>
              <a href="https://www.youtube.com/@TORCHBEARERINSITTUTE" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-amber-600"><Youtube size={20} /></a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;